import { useEffect, useRef, useState } from 'react';

import type React from 'react';

import { fieldError, setClass } from '../../helpers/utils';
import './styles.scss';

type TextareaProps = {
	className?: string;
	rows?: number;
	placeholder?: string;
	name?: string;
	value?: string;
	maxLength?: number;
	children?: React.ReactNode;
	disabled?: boolean;
	onBlur?: (e: React.FocusEvent<HTMLTextAreaElement>) => void;
	positionIcon?: string;
	hookForm?: any;
};

export const Textarea = ({
	className = '',
	rows,
	placeholder,
	name,
	value,
	maxLength,
	children,
	disabled,
	onBlur,
	positionIcon,
	hookForm = { formState: { errors: {} } } as any,
}: TextareaProps) => {
	const {
		register,
		watch,
		formState: { errors },
	} = hookForm;
	const [isFocus, setIsFocus] = useState(false);
	const [isFill, setIsFill] = useState(false);
	const [isAnimate, setIsAnimate] = useState(false);
	const areaEl = useRef(null);
	const watchInput = watch?.(name, true);
	const handleBlur = (event) => {
		setIsFocus(false);
		setAnimate();
		setIsFill(!isEmptyValue());
		if (typeof onBlur === 'function') {
			onBlur(event);
		}
	};
	const isEmptyValue = () => {
		const elem = areaEl.current;
		const textarea = elem.querySelector('textarea');
		return !(textarea.value.trim().length > 0);
	};
	const setAnimate = () => {
		if (isEmptyValue()) {
			setIsAnimate(false);
		} else {
			setIsAnimate(true);
		}
	};

	useEffect(() => {
		setAnimate();
	}, []);

	useEffect(() => {
		setIsFill(!isEmptyValue());
	}, [watchInput]);

	return (
		<div
			ref={areaEl}
			className={setClass(`textarea
          ${isAnimate || isFocus || isFill ? ' is-fill' : ''}
          ${disabled ? 'is-disabled' : ''}
          ${positionIcon ? `icon-${positionIcon}` : ''}
          ${fieldError(errors, name) ? 'is-error' : ''}
          ${className}`)}
		>
			<label className="textarea__control">
				<div className="textarea__wrap">
					<div className="textarea__label">{placeholder}</div>
				</div>
				{children}
				<textarea
					name={name}
					rows={rows}
					value={value}
					maxLength={maxLength}
					disabled={disabled}
					onFocus={() => setIsFocus(true)}
					onBlur={(e) => handleBlur(e)}
					{...register?.(name)}
				></textarea>
			</label>
			{fieldError(errors, name) && (
				<span className="message-error">
					{(fieldError(errors, name) as any).message}
				</span>
			)}
		</div>
	);
};
